export default {
    setServices(state, services) {
        state.services = services;
    },
    setTechnicians(state, technicians) {
        state.technicians = technicians;
    },
    setPeriods(state, periods) {
        state.periods = periods;
    },
    setAccounts(state, accounts) {
        state.accounts = accounts;
    }
}
